const FETCH_HOROSCOPES_REQUEST = "FETCH_HOROSCOPES_REQUEST";
const FETCH_HOROSCOPES_SUCCESS = "FETCH_HOROSCOPES_SUCCESS";
const FETCH_HOROSCOPES_FAILURE = "FETCH_HOROSCOPES_FAILURE";

export default {
  FETCH_HOROSCOPES_REQUEST,
  FETCH_HOROSCOPES_SUCCESS,
  FETCH_HOROSCOPES_FAILURE,
};
